"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Email {
}
exports.Email = Email;
//# sourceMappingURL=Email.js.map